import { EmploymentExceptionEdit } from './EmployemntExceptionEdit';
import { EmploymentExceptionCreate } from './EmploymentExceptionCreate';
import { EmploymentExceptionList } from './EmploymentExceptionList';
import { EmploymentExceptionShow } from './EmploymentExceptionShow';

export const edit = EmploymentExceptionEdit;
export const create = EmploymentExceptionCreate;
export const list = EmploymentExceptionList;
export const show = EmploymentExceptionShow;
